import { ICommon, TAddChannelToBrandRequest } from 'src/api/addChannelToBrand/types';
import { TAuthTypes } from 'src/types';
import { IFormData } from '../types';

export const buildAddPayload = (
  data: IFormData,
  authenticationType: TAuthTypes | undefined | null,
  brandId: string,
): TAddChannelToBrandRequest => {
  const { addonId, preferredName, username, endpoints, config } = data;
  const { password, contents, accessToken } = data.secrets;

  const payload: ICommon = {
    brand_id: brandId,
    addon_id: addonId,
    authentication_type: authenticationType ?? null,
    preferred_name: preferredName,
    external_id: data.externalId || null,
  };

  // Add config if any values are set
  if (config && Object.keys(config).length > 0) {
    payload.config = config;
  }

  // Add endpoints if any have values
  if (endpoints?.length > 0) {
    const endpointUpdates = endpoints
      .filter((ep) => ep.url.trim() !== '')
      .map((ep) => ({
        endpoint_id: ep.endpoint_id,
        url: ep.url.trim(),
      }));
    if (endpointUpdates.length > 0) {
      payload.endpoints = endpointUpdates;
    }
  }

  if (authenticationType === 'BASIC') {
    return { ...payload, username, password };
  }
  if (authenticationType === 'TOKEN') {
    return { ...payload, access_token: accessToken };
  }
  if (authenticationType === 'CERTIFICATE') {
    return { ...payload, contents };
  }
  return payload;
};
